import axios from "axios";
import { getCookie } from "./csrftoken";
import i18next from "i18next";

const checkInternet = async () => {
  try {
    const response = await fetch("https://www.google.com", {mode: "no-cors"});
    return i18next.t("errors.no_server_connection");
  } catch (error) {
    return i18next.t("errors.no_internet_connection");
  }
}
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const unsafe = !["get", "head", "options"].includes(method);

  if (unsafe) {
    const csrf = getCookie("csrftoken");
    if (csrf) config.headers["X-CSRFToken"] = csrf;
  }
  return config;
});

function extractError(err) {
  if (!err) return null;
  if (typeof err === "object") {
    for (const key in err) {
      if (err.hasOwnProperty(key)) {
        const value = err[key];
        if (Array.isArray(value) && value.length > 0) {
          return value[0];
        } else if (typeof value === "string") {
          return value;
        }
      }
    }
  }
  return null;
}

// function extractError(text) {
//   if (!text) return null;
//   if (typeof text === "object") {
//     if (text.error) return text.error;
//     if (text.detail) return text.detail;
//     return JSON.stringify(text);
//   }
// }

// Function to get error message from an Axios error object
export const getErrorMessage = async (error) => {
  if (!error.response) {
    var internetCheck = await checkInternet();
    return internetCheck;
  }

  switch (error.response.status) {
    case 400:
      return `Error: ${
        extractError(error.response.data) || "Bad request. Please check your input and try again."
      } `;
    case 401:
      return "Error 401: Unauthorized access. Redirecting to login.";
    case 403:
      localStorage.clear();
      window.location.href = "/login";
      return "Error 403: Forbidden access to this resource.";
    case 404:
      return "Error 404: Requested data not found. Please try again later.";
    case 406:
      return "Error 406: User already exists or has the same username with this company.";
    case 429:
      return "Error 429: Too many requests. Please try again later.";
    case 500:
      return "Error 500: Internal server error. Please try again later.";
    case 502:
      return "Error 502: Bad gateway. Please try again later.";
    case 503:
      return "Error 503: Service unavailable. Please try again later.";
    case 504:
      return "Error 504: Gateway timeout. Please try again later.";
    default:
      return `Error: ${extractError(error.response.data) || "An unexpected error occurred. Please try again later."}`;
  }
};

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Get error message using getErrorMessage function
    const errorMessage = await getErrorMessage(error);
    // Optionally, you might want to handle UI notifications here
    // For example, you could trigger a toast notification to inform the user

    // Return the error message so that it can be accessed in the component
    return Promise.reject(errorMessage);
  }
);

export default instance;
